import React from 'react';
import { Skeleton } from '@atlaskit/linking-common';
export var AssetsObjectSchemaSelectSkeleton = function AssetsObjectSchemaSelectSkeleton() {
  return /*#__PURE__*/React.createElement(Skeleton, {
    width: "100%",
    height: "40px",
    testId: "assets-datasource-modal--object-schema-select-skeleton"
  });
};